<template>
  <transition name="mask">
    <div v-if="show">
      <div class="login-modal is-authorize">
        <div class="modal-close" @click="$emit('update:show', false)"></div>
        <div class="login-modal-body">
          <form v-if="!oldTelValid" class="text-left w-full inline-block">
            <div class="h-46px cursor-default">
              <span class="inline-block w-1/3">当前手机号</span>
              <span class="inline-block w-2/3">{{
                formData.oldTel.value
              }}</span>
            </div>

            <div class="flex flex-wrap m-t-2">
              <div class="w-full md:w-2/3 pr-1">
                <input
                  :class="
                    !formData.verifyCode.error ||
                    formData.verifyCode.error.length === 0
                      ? 'input-css'
                      : 'input-css active'
                  "
                  id="verifyCode"
                  v-model="formData.verifyCode.value"
                  type="text"
                  placeholder="验证码"
                  @input="validVerifyCode(formData.verifyCode)"
                  @focus="validVerifyCode(formData.verifyCode)"
                />
                <p
                  :class="
                    formData.verifyCode.error !== ''
                      ? 'text-red text-xs italic input-error'
                      : 'text-red text-xs italic input-error hidden'
                  "
                >
                  {{ formData.verifyCode.error }}
                </p>
              </div>

              <div class="w-full md:w-1/3 pl-1" @click="sendMobileCode">
                <div
                  :class="
                    isNaN(code)
                      ? 'input-border-btn'
                      : 'input-border-btn disabled'
                  "
                >
                  {{ code }}{{ isNaN(code) ? '' : ' S' }}
                </div>
              </div>
            </div>

            <div class="flex items-center justify-between m-t-20 md:w-1/2">
              <div class="input-border-btn" @click="checkForm">
                验证当前手机号
              </div>
            </div>
          </form>

          <form v-if="oldTelValid" class="text-left w-full inline-block">
            <MobileCode
              ref="validInput"
              type="revise"
              :data="formData"
            ></MobileCode>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import valid from '@/core/mixins/valid'
import MobileCode from '@/components/common/MobileCode'
import { getMobileUnbindCode, getMobileUnbind } from '@/core/api'

export default {
  name: 'login-bar',
  mixins: [valid],
  components: {
    MobileCode
  },
  props: {
    show: null,
    formData: null
  },
  data() {
    return {
      oldTelValid: false,
      code: '获取验证码'
    }
  },
  computed: {
    isAuthorize() {
      return this.formData.oldTel.value
    }
  },
  mounted() {
    this.getMobileCodeExpireTime()
  },
  methods: {
    getMobileCodeExpireTime() {
      let mobileCodeExpireTimeUnbind = JSON.parse(
        localStorage.getItem('mobileCodeExpireTimeUnbind')
      )
      if (
        mobileCodeExpireTimeUnbind &&
        +new Date() < mobileCodeExpireTimeUnbind.time
      ) {
        this.formData.oldTel.mobile = mobileCodeExpireTimeUnbind.mobile
        let time = parseInt(
          (mobileCodeExpireTimeUnbind.time - +new Date()) / 1000
        )
        this.countDown(time)
      } else {
        localStorage.removeItem('mobileCodeExpireTimeUnbind')
      }
    },
    countDown(time) {
      this.code = time
      let t = setInterval(() => {
        this.code--
        if (this.code === 0) {
          this.code = '发送验证码'
          clearInterval(t)
        }
      }, 1000)
    },
    async sendMobileCode() {
      let _this = this
      if (!isNaN(this.code)) {
        return
      }
      let validOldTel, data
      validOldTel = this.validTel(this.formData.oldTel)
      data = this.formData.oldTel.value

      if (validOldTel) {
        localStorage.setItem(
          'mobileCodeExpireTimeUnbind',
          JSON.stringify({
            time: +new Date() + 120000,
            mobile: data
          })
        )
        this.countDown(120)

        try {
          let res = await getMobileUnbindCode(data)
          // console.log(res) // eslint-disable-line no-console
          if (res.status === 200) {
            this.$swal({
              position: 'top-end',
              type: 'success',
              toast: true,
              text: res.data.mobile[0].split('，')[0],
              showConfirmButton: false,
              timer: 3000
            })
          }
        } catch (e) {
          // console.log(e.response) // eslint-disable-line no-console
          let res = e.response
          if (res.status === 422) {
            _this.formData.oldTel.error = res.data.mobile[0]
          }
        }
      }
    },
    async checkForm(e) {
      this.errors = []
      let _this = this
      let validTel, validVerifyCode
      validTel = this.validTel(this.formData.oldTel)
      validVerifyCode = this.validVerifyCode(this.formData.verifyCode)
      if (validTel && validVerifyCode) {
        let data = {
          mobile: this.formData.oldTel.value,
          code: this.formData.verifyCode.value
        }
        try {
          let res = await getMobileUnbind(data)
          if (res.status === 200) {
            _this.$swal({
              position: 'top-end',
              type: 'success',
              toast: true,
              text: '当前手机号已验证成功，请绑定新手机号！',
              showConfirmButton: false,
              timer: 3000
            })
            this.$store.dispatch('SubscriberStore/fetch') // 获取个人信息
            let t = setTimeout(function() {
              _this.$set(_this, 'oldTelValid', true)
              clearTimeout(t)
            }, 3000)
          }
        } catch (e) {
          // console.log(e.response) // eslint-disable-line no-console
          let res = e.response
          if (res.status === 422) {
            this.formData.verifyCode.error = res.data.code[0]
          }
        }
      }

      e.preventDefault()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.mask-enter-active,
.mask-leave-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}

.mask-enter,
.mask-leave-to {
  opacity: 0;
}

.login-modal {
  width: 490px;
  margin: 0 auto;
  outline: 0;
  top: 50%;
  left: 50%;
  background-color: $c-transparent;
  color: $c-white;
  position: absolute;
  margin-top: -200px;
  margin-left: -245px;
  z-index: 1001;
}

// .login-modal-header {
//   padding: 0 20px;
//   width: 100%;
//   height: 58px;
//   line-height: 58px;
//   text-align: right;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   vertical-align: middle;
//   white-space: nowrap;
// }

.login-modal-body {
  padding: 42px 50px 33px;
  text-align: center;
  // .input-css {
  //   margin-bottom: 18px;
  // }
  .input-full-btn {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.login-modal-img {
  padding: 20px 20px 0px;
  text-align: center;
}

// .qr-code {
//   display: inline-block;
//   margin: 30px 0;
//   border: 1px solid $c-m-gray-light;
//   width: 220px;
//   height: 220px;
//   line-height: 218px;

//   img {
//     width: 94%;
//     height: 94%;
//   }
// }
// .register-css {
//   padding: 42px 0 33px !important;
// }
.text-muted {
  font-size: 16px;
}
.login-modal.is-authorize {
  background-color: $c-tour-0;

  .login-modal-img {
    display: none;
  }
  .login-modal-body {
    background-image: url('../../../static/images/public/bg-flower-g.png');
    background-repeat: no-repeat;
    background-size: auto 310px;
    background-position: 310px -30px;
  }
  .h-46px {
    height: 46px;
    line-height: 46px;
    margin-bottom: 10px;
  }
}
</style>
